package com.essntl.features.organization.domain.model

import com.essntl.features.address.domain.model.AddressModel

data class OrganizationModel(
    val id: String,
    val name: String,
    val address: AddressModel?,
    val website: String?,
    val logoFileId: String?,
    val parentId: String?,
    val notes: String?,
    val type: Type?,
    val createdAt: String,
    val updatedAt: String,
) {
    enum class Type {
        TravelAgency,
        Supplier,
        DMC
    }

    val isEmpty
        get() = this.copy(id = "", createdAt = "", updatedAt = "") == empty

    companion object {
        val empty =
            OrganizationModel(
                id = "",
                name = "",
                address = null,
                website = "",
                logoFileId = null,
                parentId = null,
                notes = null,
                type = null,
                createdAt = "",
                updatedAt = "",
            )
    }
}